//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../../index";

// state
const subaffiliateReportV2OptionsDataSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.options.data;
const subaffiliateReportV2OptionsErrorSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.options.error;
const subaffiliateReportV2OptionsFetchingSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.options.isFetching;

const subaffiliateReportV2ListDataSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.list.data;
const subaffiliateReportV2ListErrorSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.list.error;
const subaffiliateReportV2ListFetchingSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.list.isFetching;

const subaffiliateReportV2ColumnsDataSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.columns.data;
const subaffiliateReportV2ColumnsErrorSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.columns.error;

const subaffiliateReportV2DownloadDataSelector = (state: RootState) => state.affiliate.subaffiliate_report_v2.download.data;

//selectors
export const selectOptionsData = createSelector(subaffiliateReportV2OptionsDataSelector, (data) => data);
export const selectOptionsError = createSelector(subaffiliateReportV2OptionsErrorSelector, (error) => error);
export const selectOptionsIsFetching = createSelector(subaffiliateReportV2OptionsFetchingSelector, (isFetching) => isFetching);

export const selectListData = createSelector(subaffiliateReportV2ListDataSelector, (data) => data);
export const selectListDataColumnsSort = createSelector(subaffiliateReportV2ListDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));
export const selectListError = createSelector(subaffiliateReportV2ListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(subaffiliateReportV2ListFetchingSelector, (isFetching) => isFetching);

export const selectColumnsData = createSelector(subaffiliateReportV2ColumnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(subaffiliateReportV2ColumnsErrorSelector, (error) => error);

export const selectDownloadData = createSelector(subaffiliateReportV2DownloadDataSelector, (data) => data);
